/**
 * DS Compare — Clear stale status messages
 * ---------------------------------------------------------------
 * The photo dropzone and the link field each keep their own status node. An
 * error from one used to sit there while the other succeeded — a failed photo
 * attempt would still show "Couldn't read that photo" next to a perfectly good
 * link result. Whenever either path starts or succeeds, clear the other.
 */
(function () {
  function clear(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = true;
    el.innerHTML = '';
    el.classList.remove('is-error');
    delete el.dataset.dscmpDecorated;
  }

  function clearPhoto() { clear('dscmp-uploadstate'); }
  function clearLink() { clear('dscmp-urlstate'); }

  /* Starting a link lookup clears any old photo error, and vice versa. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#dscmp-urlgo')) clearPhoto();
    if (t.closest('#dscmp-upload')) clearLink();
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.id === 'dscmp-file') clearLink();
    if (e.target.id === 'dscmp-select' && e.target.value) {
      clearPhoto();
      clearLink();
    }
  }, true);

  document.addEventListener('drop', function (e) {
    if (e.target && e.target.closest && e.target.closest('#dscmp-upload')) clearLink();
  }, true);

  document.addEventListener('paste', function () {
    var modal = document.getElementById('dscmp-modal');
    if (modal && !modal.hidden) clearLink();
  }, true);

  /* A competitor card loading successfully means every prior error is moot. */
  function watch() {
    var card = document.getElementById('dscmp-vscard');
    if (!card || card.dataset.dscmpClear === '1') return;
    card.dataset.dscmpClear = '1';
    new MutationObserver(function () {
      if (!card.classList.contains('is-empty')) {
        clearPhoto();
        clearLink();
      }
    }).observe(card, { attributes: true, attributeFilter: ['class'] });
  }

  var mo = new MutationObserver(watch);

  function start() {
    watch();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
